import { RootState } from '../../../app/store';
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit"
import { OrderDirection } from '../../Datatable/OrderDirection';
import BrokerAccountQueryModel from '../models/BrokerAccountQueryModel';
import BrokerAccountModel from '../models/BrokerAccountModel';
import { QueryItem } from '../../Tonnage/models/TonnageQueryModel';
import ContactNameModel from '../../ContactSelector/models/ContactNameModel';

interface BrokerAccountSearchState {
    query: BrokerAccountQueryModel,
    searchResults: BrokerAccountModel[],
    contactSearchKeyword: string,
    contactAccountNames: ContactNameModel[],
    triggerSearch: number,
    datatableSelectedIndex: number,
    searchResultTotalRecord: number,
    triggerFocusCompanyName: number
    checkedBrokerAccounts: BrokerAccountModel[],
    showInputPanel: boolean,
}

const initialState: BrokerAccountSearchState = {
    query: {
        contactNames: [],
        micNames: [],
        accountTypes: [],
        brokers: [],
        StartedDateFrom: "",
        StartedDateTo: "",
        expiredDateFrom: "",
        expiredDateTo: "",
        remainingTime: 0,
        orderBy: "updatedDate",
        orderDirection: OrderDirection.Desc,
    } as BrokerAccountQueryModel,
    searchResults: [],
    contactSearchKeyword: "",
    contactAccountNames: [],
    triggerSearch: 0,
    datatableSelectedIndex: -1,
    searchResultTotalRecord: 0,
    triggerFocusCompanyName: 0,
    checkedBrokerAccounts: [],
    showInputPanel: false
}

export const BrokerAccountSearchSlice = createSlice({
    name: "BrokerAccountSearch",
    initialState,
    reducers: {
        setContactNames: (state, action: PayloadAction<QueryItem[]>) => {
            state.query.contactNames = action.payload;
        },
        setMicNames: (state, action: PayloadAction<QueryItem[]>) => {
            state.query.micNames = action.payload;
        },
        setAccountTypes: (state, action: PayloadAction<QueryItem[]>) => {
            state.query.accountTypes = action.payload;
        },
        setBrokers: (state, action: PayloadAction<QueryItem[]>) => {
            state.query.brokers = action.payload;
        },
        setStartedDateFrom: (state, action: PayloadAction<string>) => {
            state.query.StartedDateFrom = action.payload;
        },
        setStartedDateTo: (state, action: PayloadAction<string>) => {
            state.query.StartedDateTo = action.payload;
        },
        setExpiredDateFrom: (state, action: PayloadAction<string>) => {
            state.query.expiredDateFrom = action.payload;
        },
        setExpiredDateTo: (state, action: PayloadAction<string>) => {
            state.query.expiredDateTo = action.payload;
        },
        setOrderBy: (state, action: PayloadAction<string>) => {
            state.query.orderBy = action.payload;
        },
        setOrderDirection: (state, action: PayloadAction<OrderDirection>) => {
            state.query.orderDirection = action.payload;
        },
        setBrokerAccountSearchResults: (state, action: PayloadAction<BrokerAccountModel[]>) => {
            state.searchResults = action.payload;
        },
        setContactSearchKeyword: (state, action: PayloadAction<string>) => {
            state.contactSearchKeyword = action.payload;
        },
        setTriggerBrokerAccountSearch: (state, action: PayloadAction<number>) => {
            state.triggerSearch = action.payload;
        },
        setDatatableSelectedBrokerAccountIndex: (state, action: PayloadAction<number>) => {
            state.datatableSelectedIndex = action.payload;
        },
        setSearchResultTotalRecord: (state, action: PayloadAction<number>) => {
            state.searchResultTotalRecord = action.payload;
        },
        setBrokerAccountquery: (state, action: PayloadAction<BrokerAccountQueryModel>) => {
            state.query = action.payload;
        },
        setContactAccountNames: (state, action: PayloadAction<ContactNameModel[]>) => {
            state.contactAccountNames = action.payload;
        },
        resetBrokerAccountSearch: (state) => {
            state.query = initialState.query;
        },
        setTriggerFocusCompanyName: (state, action: PayloadAction<number>) => {
            state.triggerFocusCompanyName = action.payload;
        },
        setCheckedBrokerAccounts: (state, action: PayloadAction<BrokerAccountModel[]>) => {
            state.checkedBrokerAccounts = action.payload;
        },
        setShowInputBrokerAccountPanel: (state, action: PayloadAction<boolean>) => {
            state.showInputPanel = action.payload;
        },
    }
});

export const BrokerAccountSearchSelector = createSelector(
    (state: RootState) => state.brokerAccountSearch,
    (data) => data
);

export const {
    setOrderBy,
    setOrderDirection,
    setBrokerAccountSearchResults,
    setContactSearchKeyword,
    setContactNames,
    setMicNames,
    setAccountTypes,
    setBrokers,
    setStartedDateFrom,
    setStartedDateTo,
    setExpiredDateFrom,
    setExpiredDateTo,
    setTriggerBrokerAccountSearch,
    setDatatableSelectedBrokerAccountIndex,
    setSearchResultTotalRecord,
    setBrokerAccountquery,
    resetBrokerAccountSearch,
    setTriggerFocusCompanyName,
    setCheckedBrokerAccounts,
    setShowInputBrokerAccountPanel,
    setContactAccountNames
} = BrokerAccountSearchSlice.actions;

export default BrokerAccountSearchSlice.reducer;